module.exports = __webpack_public_path__ + "img/gift_voucher.a9493eab.svg";